<script setup lang="ts">
import { ref } from "vue";
import { Collapse } from "vue-collapsed";
import { Attraction } from "../interfaces/hotelDetailsResponse";

const showAttractions = ref(false);

interface Props {
  haveAttractions: boolean;
  attractions: Attraction[];
  mediaQueries: {
    isDesktop: boolean;
    isMobile: boolean;
  };
}

defineProps<Props>();
</script>

<template>
  <div
    v-if="haveAttractions"
    class="grid w-full rounded-md border bg-white p-4 shadow-sm"
  >
    <div class="flex items-center justify-between">
      <p class="text-base font-medium sm:text-lg">Puntos de interés</p>

      <figure
        v-if="mediaQueries.isDesktop && haveAttractions"
        class="flex cursor-pointer items-center justify-center gap-1"
        @click="showAttractions = !showAttractions"
      >
        <span class="text-sm">{{
          `${showAttractions ? "Ocultar" : "Mostrar"}`
        }}</span>

        <span
          :class="[
            'material-symbols-outlined mt-1',
            showAttractions && 'mt-0 rotate-180',
          ]"
        >
          expand_more
        </span>
      </figure>
    </div>

    <Collapse
      :when="mediaQueries.isMobile || showAttractions"
      class="v-collapse"
    >
      <ul
        class="grid list-inside list-disc gap-2 mt-4 pb-2 text-justify md:px-2 md:pr-3"
      >
        <template v-for="(location, index) in attractions" :key="index">
          <div class="flex grid-cols-2 items-center">
            <div class="mr-2 flex w-full items-center justify-start gap-2">
              <span class="material-symbols-outlined text-md">
                location_on
              </span>
              <p
                :class="[
                  'hyphens-auto break-words text-left text-xs sm:text-sm',
                ]"
                lang="es"
              >
                {{ location.name }}
              </p>
            </div>

            <div class="flex w-full items-center justify-end">
              <p class="whitespace-nowrap text-right text-xs sm:text-sm">
                {{ location.refPoints[0].toFrom }} el Hotel
                {{ `${location.refPoints[0].distance} KM` }}
              </p>
            </div>
          </div>
        </template>
      </ul>
    </Collapse>
  </div>
</template>
